
import {connect} from 'react-redux';
import axios from 'axios';

import {Alert, Platform} from "react-native"

import ChangeInformationSatiaScreen from '../ChangeInformationSatiaScreen';

import i18n from "../../../../../I18n/i18n";
import * as NavigationService from "../../../../../redux/NavigationService";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import {
    serviceActionSetState, serviceActionSetToken,
    serviceActionSetUser,
    serviceActionSetWallet
} from "../../../splash/action/ActionSplashSatiaScreen";
import HMAlert from "../../../../../customviews/HMAlert";
const mapStateToProps = (state) => ({
    results: state.reducerChangeInformationSatiaScreen.results,
    NoInternetDialog: state.reducerChangeInformationSatiaScreen.NoInternetDialog,
    isLoading: state.reducerChangeInformationSatiaScreen.isLoading,

    user: state.reducerSplashSatiaScreen.user,
    token: state.reducerSplashSatiaScreen.token,

});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(url, params, type, typeConnection, token)),
    callServiceSetUser: (user) => dispatch(serviceActionSetUser(user)),
    callserviceActionRefresh: (user) => dispatch(serviceActionRefresh(user)),
    callServiceSetToken: (token) => dispatch(serviceActionSetToken(token)),
    callServiceSetWallet: (data, typeWallet) => dispatch(serviceActionSetWallet(data, typeWallet)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),


})

const getDataDisatch = (dispatch, url, params, type, typeConnection, token) => {
    dispatch(serviceActionPending());


    /* axios(
         {
             url: baseUrl + url + params,
             method: typeConnection,
             headers: {
                 'Content-Type': 'application/x-www-form-urlencoded',
                 "Authorization":  token,

             },

         }
     )*/
    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // 'Content-Type': 'application/json',
            "Authorization": `Basic ${params.token}`
        }
    };
    const formData = new FormData();
    formData.append('_operation', typeExport._Contacts);
    formData.append('mode', "UpdateContact");
    formData.append('lang', params.lang);
    formData.append('token', params.token);
    formData.append('firstname', params.firstname);
    formData.append('lastname', params.lastname);
    formData.append('token_fb', store.getState().reducerSplashGetAllData.token_fb);
    formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
   // axios.post(url, formData, config)

        .then(async response => {
            let data = response.data;
            switch (type) {

                case typeExport.TypegetDataChangeInformationSatiaScreen:
                    HMAlert(i18n.t('constant.message'), "ویرایش با موقیت انجام شد", [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            {text: i18n.t('constant.ok'), onPress: () => NavigationService.Pop()},
                        ],
                        {cancelable: true}
                    )
                    dispatch(serviceActionSuccess(data))
                    if (data.success === true) {
                        if (data.result.user !== null && data.result.user !== undefined) {
                            await AsyngStorageClass.setAsyng(typeExport._USER, data.result.user);
                            dispatch(serviceActionSetUser(data.result.user))
                        }

                    }
                    break;
                default:
            }
        }).catch((e) => {
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (url, params, type, typeConnection, token) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection,token);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //         }
        //     }
        // )


                if (store.getState().reducerSplashSatiaScreen.Connection) {
                    getDataDisatch(dispatch, url, params, type, typeConnection, token);
                } else {
                    dispatch(serviceActionError("No Internet Connection"));
                }



        // NetInfo.getConnectionInfo().).done(
        //     (isConnected) => {
        //
        //     }
        // )

    }
}


export const serviceActionPending = () => ({
    type: typeExport.ChangeInformationSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type:  typeExport.ChangeInformationSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type:  typeExport.ChangeInformationSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type:  typeExport.ChangeInformationSatiaScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(ChangeInformationSatiaScreen);
